import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { Parser } from 'json2csv';
import FileSaver from 'file-saver';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { NotificationContainer, NotificationManager, } from "react-notifications";

const DashboardTable = ({ event, title, type,status ,gender,province,searchResults,check}) => {
    console.log("event",event)
    console.log("title",title)
    console.log("type",type)
    console.log("status",status)
    console.log("gender",gender)
    console.log("province",province)

    const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
    console.log("token",token)
    const authUserInfo = JSON.parse(localStorage.getItem('auth_user_info')); // Get the stored JSON string and parse it to an object
    const campaignId = localStorage.getItem('campaigin_id');
    const userId = authUserInfo.id; // Access the 'id' property
    console.log("User ID:", userId);
    const navigate = useNavigate();
    const [realapplications, setRealApplications] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedDocumentId, setSelectedDocumentId] = useState(null);

    const [allocatedFunds, setAllocatedFunds] = useState(0);
    const [fundsRequested, setFundsRequested] = useState(0);
    const [chalan, setChalan] = useState(0);

    
    const [loading, setLoading] = useState(false);
    // Unsaved per-row remarks edits, keyed by application id. Falls back to
    // application.remarks once a row has no draft.
    const [remarksDrafts, setRemarksDrafts] = useState({});
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);  // 0-based index for react-paginate

    const pageSize = 20;
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState("desc");

    const handleSort = (field) => {
      setCurrentPage(0);
      if (sortField === field) {
        setSortOrder((currentOrder) => currentOrder === "asc" ? "desc" : "asc");
      } else {
        setSortField(field);
        setSortOrder("asc");
      }
    };

    const renderSortableHeader = (label, field) => (
      <th key={field} aria-sort={sortField === field ? (sortOrder === "asc" ? "ascending" : "descending") : "none"}>
        <button
          type="button"
          className="btn btn-link p-0 text-reset text-decoration-none"
          onClick={() => handleSort(field)}
          aria-label={`Sort by ${label} ${sortField === field && sortOrder === "asc" ? "descending" : "ascending"}`}
        >
          {label}
          <span className="ms-1" aria-hidden="true">
            {sortField === field ? (sortOrder === "asc" ? "▲" : "▼") : "↕"}
          </span>
        </button>
      </th>
    );

  //   if (status) {
  //     api = `${process.env.REACT_APP_BASE_URL_strapi}/applications?filters[application_status][$eq]=${status}&populate[evaluations][populate]=users_permissions_user&pagination[pageSize]=${pageSize}&pagination[page]=${currentPage + 1}` ;
  // } else if (gender) {
  //     api = `${process.env.REACT_APP_BASE_URL_strapi}/applications?filters[gender][$eq]=${gender}&populate[evaluations][populate]=users_permissions_user&pagination[pageSize]=${pageSize}&pagination[page]=${currentPage + 1}`;
  // } else if (province) {
  //     api = `${process.env.REACT_APP_BASE_URL_strapi}/applications?filters[province][$eq]=${province}&populate[evaluations][populate]=users_permissions_user&pagination[pageSize]=${pageSize}&pagination[page]=${currentPage + 1}`;
  // }


  // Fetch Applications and Evaluations information
//   useEffect(() => {
//     const fetchApplicationsWithEvaluations = async () => {
//         try {
//             const response = await fetch(api, {
//                 method: 'GET',
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json',
//                 },
//             });

//             const applicationsData = await response.json();
//             const applications = applicationsData.data;
//                console.log("1122",applications)
//             // Process evaluations and calculate the sum of the relevant fields
//             const updatedApplications = applications?.map(application => {
//                 const evaluations = application.evaluations || [];

//                 const updatedEvaluations = evaluations.map(evaluation => {
//                     const attributes = evaluation;
//                     // Calculate the sum of desired fields
//                     const sum = (attributes.academic_performance || 0) +
//                                 (attributes.financial_need || 0) +
//                                 (attributes.personal_statement || 0);

//                     // Return evaluation with the sum
//                     return {
//                         ...evaluation,
//                         sum: sum, // Add the sum field to the evaluation
//                     };
//                 });

//                 // Update the application with the modified evaluations
//                 return {
//                   ...application,
//                   evaluations: updatedEvaluations, // Update the evaluations while keeping the format unchanged
//                 };
//             });
//          console.log("updatedApplications",updatedApplications)
//          console.log("updatedApplications",updatedApplications[0]?.attributes?.evaluations?.data?.[0]?.sum)
//             setRealApplications(updatedApplications);
//         } catch (error) {
//             console.error('Error fetching applications and evaluations:', error);
//         }
//     };

//     if (api) {
//         fetchApplicationsWithEvaluations();
//     }
// }, [api, token ,currentPage]);

const openFinancePopup = async (documentid,id ) => {
  console.log("whats id comming ",documentid)
  await getfinanceamount(documentid)
  setSelectedId(id);
  setSelectedDocumentId(documentid)
  setShowPopup(true);
};
const handleFinanceSave = async () => {
  try {
  
    console.log("Saving allocated funds:", allocatedFunds);

    // ------------------------
    // Dummy API CALL (replace)
    // ------------------------
    await saveFinance(selectedDocumentId, allocatedFunds);

    // Close popup
    setShowPopup(false);

    // Now call your YES function
    await yes(selectedId);

  } catch (error) {
    console.error("Finance Save Error:", error);
  }
};

const saveFinance = async (selectedId,allocatedFunds) => {
  try {
    console.log("finance amount ", allocatedFunds);

    const createResponse = await fetch(
      `${process.env.REACT_APP_BASE_URL_strapi}/finance-amounts`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Pass the token for authentication
        },
        body: JSON.stringify({
          data: {
            amount: allocatedFunds,
            application: selectedId, // Send the application ID
          },
        }),
      }
    );

    if (createResponse.ok) {
      const responseData = await createResponse.json();
      console.log("finance added successfully:", responseData);

      // Show success notification
      NotificationManager.success("Funds added sucessfully");


    } else {
      const errorData = await createResponse.json();
      console.error("Failed to save finance amount:", errorData);

      // Show error notification
      NotificationManager.error(
        "Failed to save finance amount. Please try again.",
        "Error"
      );
    }
  } catch (error) {
    console.error("Error occurred while saving finance amount:", error);

    // Show error notification for unexpected issues
    NotificationManager.error(
      "An unexpected error occurred. Please try again later.",
      "Error"
    );
  }
};
const getfinanceamount = async (id) => {
  try {
    const response6 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/finance-amounts?filters[application][documentId][$eq]=${id}&populate=*
      `, {
          headers: {
              'Authorization': `Bearer ${token}`, // Your JWT token
              'Content-Type': 'application/json'
          }
      });
      const response4 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/finance-details?filters[application][documentId][$eq]=${id}&populate=*
        `, {
            headers: {
                'Authorization': `Bearer ${token}`, // Your JWT token
                'Content-Type': 'application/json'
            }
        });
        const data4 = await response4.json();

      const data6 = await response6.json();
      console.log("is fund comming here ",data6?.data[0]?.amount)
      setAllocatedFunds(data6?.data[0]?.amount)
      setFundsRequested(data4?.data[0]?.funds_request)
      setChalan(data4?.data[0]?.chalan)

  } catch (error) {
    console.error("Error fetching applications:", error);
  }
};
useEffect(() => {
  let api = null;
  NotificationManager.list = [];

  if (searchResults) {
    console.log("Search Results:", searchResults);
    
    // Update applications with search results
    const applications = searchResults.data;

    // Set total pages based on search results
    setTotalPages(searchResults.meta.pagination.pageCount);
    setCurrentPage(searchResults.meta.pagination.page - 1); // Adjust to 0-based index

    // Process evaluations and calculate the sum of the relevant fields
    const updatedApplications = applications?.map(application => {
      const evaluations = application.evaluations || [];

      const updatedEvaluations = evaluations.map(evaluation => {
          const attributes = evaluation;
          // Calculate the sum of desired fields
          const sum = (attributes.academic_performance || 0) +
                      (attributes.financial_need || 0) +
                      (attributes.personal_statement || 0);

          // Return evaluation with the sum
          return {
              ...evaluation,
              sum: sum, // Add the sum field to the evaluation
          };
      });

      // Update the application with the modified evaluations
      return {
        ...application,
        evaluations: updatedEvaluations, // Update the evaluations while keeping the format unchanged
      };
  });
console.log("updatedApplications",updatedApplications)
console.log("updatedApplications",updatedApplications[0]?.attributes?.evaluations?.data?.[0]?.sum)
  const sortedApplications = [...(updatedApplications || [])].sort((left, right) => {
    const leftValue = left[sortField];
    const rightValue = right[sortField];
    if (leftValue == null || leftValue === "") return rightValue == null || rightValue === "" ? 0 : 1;
    if (rightValue == null || rightValue === "") return -1;
    const comparison = String(leftValue).localeCompare(String(rightValue), undefined, {
      numeric: true,
      sensitivity: "base",
    });
    return sortOrder === "asc" ? comparison : -comparison;
  });
  setRealApplications(sortedApplications);
  setRemarksDrafts({});
  } else {
    // Build and fetch default data using the existing logic
 

    if (status) {
      api = `${process.env.REACT_APP_BASE_URL_strapi}/applications?filters[application_status][$eq]=${status}&filters[campaign][id][$eq]=${campaignId}&populate[evaluations][populate]=users_permissions_user&populate[finance_amount][populate]=*&populate[finance_details][populate]=*&sort=${sortField}:${sortOrder}&pagination[pageSize]=${pageSize}&pagination[page]=${currentPage + 1}`;
    } else if (gender) {
      api = `${process.env.REACT_APP_BASE_URL_strapi}/applications?filters[$and][0][gender][$eq]=${gender}&filters[$and][1][$or][0][application_status][$eq]=new&filters[$and][1][$or][1][application_status][$eq]=rejected&filters[$and][1][$or][2][application_status][$eq]=final_stage&filters[$and][1][$or][3][application_status][$eq]=approved&filters[$and][2][campaign][id][$eq]=${campaignId}&populate[evaluations][populate]=users_permissions_user&sort=${sortField}:${sortOrder}&pagination[pageSize]=${pageSize}&pagination[page]=${currentPage + 1}`;
    } else if (province) {
      api = `${process.env.REACT_APP_BASE_URL_strapi}/applications?filters[province][$eq]=${province}&filters[$and][1][$or][0][application_status][$eq]=new&filters[$and][1][$or][1][application_status][$eq]=rejected&filters[$and][1][$or][2][application_status][$eq]=final_stage&filters[$and][1][$or][3][application_status][$eq]=approved&filters[$and][2][campaign][id][$eq]=${campaignId}&populate[evaluations][populate]=users_permissions_user&sort=${sortField}:${sortOrder}&pagination[pageSize]=${pageSize}&pagination[page]=${currentPage + 1}`;
    }
    


    // Fetch default applications with the existing API logic
    const fetchApplicationsWithEvaluations = async () => {
      try {
        const response = await fetch(api, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const applicationsData = await response.json();
          const applications = applicationsData.data;
          setTotalPages(applicationsData.meta.pagination.pageCount);
          setCurrentPage(applicationsData.meta.pagination.page - 1); // Adjust to 0-based index

          // Process evaluations and calculate the sum of the relevant fields
          const updatedApplications = applications?.map(application => {
                            const evaluations = application.evaluations || [];
            
                            const updatedEvaluations = evaluations.map(evaluation => {
                                const attributes = evaluation;
                                // Calculate the sum of desired fields
                                const sum = (attributes.academic_performance || 0) +
                                            (attributes.financial_need || 0) +
                                            (attributes.personal_statement || 0);
            
                                // Return evaluation with the sum
                                return {
                                    ...evaluation,
                                    sum: sum, // Add the sum field to the evaluation
                                };
                            });
            
                            // Update the application with the modified evaluations
                            return {
                              ...application,
                              evaluations: updatedEvaluations, // Update the evaluations while keeping the format unchanged
                            };
                        });
                     console.log("updatedApplications",updatedApplications)
                     console.log("updatedApplications",updatedApplications[0]?.attributes?.evaluations?.data?.[0]?.sum)
                        setRealApplications(updatedApplications);
                        setRemarksDrafts({});
        } else {
          console.error("Failed to fetch applications:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching applications:", error);
      }
    };

    fetchApplicationsWithEvaluations(); 

  }
}, [searchResults, status, gender, province, currentPage, token, sortField, sortOrder]);

    // // Fetch Applications information and download as Excel
    // const fetchDataAndDownload = async () => {
    //     try {
    //         const response = await axios.get(
    //             `${process.env.REACT_APP_BASE_URL}/applicant/get-application-list`,
    //             {
    //                 headers: {
    //                     accept: "*/*",
    //                     Event: event,
    //                     SessionKey: "123",
    //                 },
    //                 responseType: 'blob', // Tell axios to get the response as a Blob
    //             }
    //         );
    //         const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    //         FileSaver.saveAs(blob, 'data.xlsx');
    //         setLoading(false);

    //     } catch (error) {
    //         console.error("Error fetching personal information data:", error);
    //         setLoading(false);
    //     }
    // };

    // Fetch Applications information and download as CSV


    // Function to convert JSON data to CSV
    const jsonToCsv = (data) => {
      if (!data || data.length === 0) return '';
      console.log("data test", data);
    
      // Define fields to exclude
      const excludeFields = [
        'createdAt', 'updatedAt', 'publishedAt', 'province', 'attributes',
        'recover_status', 'admin1', 'admin2', 'admin3', 'evaluations',
        'skills', 'social_media', 'project_detail', 'documentId'
      ];
    
      // Extract headers, excluding unwanted fields, and add "personal_statement" explicitly
      const mainHeaders = Object.keys(data[0]).filter((key) => !excludeFields.includes(key));
      mainHeaders.push("personal_statement"); // Add "personal_statement" to headers
    
      // Create CSV header row
      const csvRows = [mainHeaders.map((header) => `"${header}"`).join(',')];
    
      // Helper function to escape values
      const escapeValue = (value) => {
        if (value === null || value === undefined) return '""';
        const escapedValue = value.toString().replace(/"/g, '""');
        return `"${escapedValue}"`;
      };
    
      // Process each row of data
      data.forEach((item) => {
        const rowValues = mainHeaders.map((header) => {
          if (header === "personal_statement") {
            // Extract the first item's personal_statement from personal_statements array
            return item.personal_statements?.length > 0 
              ? escapeValue(item.personal_statements[0].personal_statement) 
              : '""';
          }
          return escapeValue(item[header]);
        });
    
        csvRows.push(rowValues.join(','));
      });
    
      return csvRows.join('\n'); // Join all rows with newlines
    };
    
    


    const handleLoginByEmail = async (email) => {
    
      try {
        // Call your custom endpoint
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL_strapi}/login/loginByEmail`,
          { email }
        );
    
        console.log("response", response);
    
        if (response.data.user) {
          let auth_user_info;
    
          if (response.data.user.type === "admin") {
            auth_user_info = {
              id: response.data.user.id,
              username: response.data.user.username,
              name: response.data.user.first_name,
              designation: response.data.user.designation,
              type: response.data.user.type,
            };
          } else {
            auth_user_info = {
              id: response.data.user.id,
              type: response.data.user.type,
              fname: response.data.user.first_name,
              lname: response.data.user.last_name,
              email1: response.data.user.email,
              status: response.data.user.blocked,
            };
          }
    
          localStorage.setItem("auth_user_info", JSON.stringify(auth_user_info));
          localStorage.setItem("token", response.data.jwt);
    
          if (response && response.data && response.data.user) {
            const { type } = response.data.user;
    
            if (type === "admin") {
              navigate("/dashboard");
            } else if (type === "applicant") {
              // First navigate to the instructions page
              navigate("/application/instructions");
    
              // Now handle the two additional API requests for applicants
              const token = response.data.jwt;
    
              try {
                // Fetch the latest campaign
                const campaignResponse = await fetch(
                  `${process.env.REACT_APP_BASE_URL_strapi}/campaigns?sort=createdAt:desc&pagination[limit]=1`,
                  {
                    method: "GET",
                    headers: {
                      Authorization: `Bearer ${token}`, // JWT token of the logged-in user
                    },
                  }
                );
    
                const latestCampaignResponse = await campaignResponse.json();
                const latestCampaign = latestCampaignResponse.data[0]; // Get the latest campaign
    
                if (!latestCampaign) {
                  console.error("No campaign found");
                  return;
                }
    
                console.log("Latest campaign:", latestCampaign);
    
                // Fetch user applications related to the latest campaign
                const userApplicationsResponse = await fetch(
                  `${process.env.REACT_APP_BASE_URL_strapi}/users/me?populate[applications][filters][campaign][documentId][$eq]=${latestCampaign.documentId}`,
                  {
                    method: "GET",
                    headers: {
                      Authorization: `Bearer ${token}`, // JWT token of the logged-in user
                    },
                  }
                );
    
                const userApplications = await userApplicationsResponse.json();
                console.log("User with filtered applications:", userApplications);
    
                const applications = userApplications.applications;
                if (applications && applications.length > 0) {
                  const applicationId = applications[0].id;
                  const documentId = applications[0].documentId
                  const applicationstatus = applications[0].application_status;
                  localStorage.setItem("id", applicationId);
  
                  localStorage.setItem("application_status", applicationstatus);
                  
                  // Fetch full application details for this application ID
                  try {
                   
                    const response2 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/academic-details?filters[application][documentId][$eq]=${documentId}&populate=*
                      `, {
                          headers: {
                              'Authorization': `Bearer ${token}`, // Your JWT token
                              'Content-Type': 'application/json'
                          }
                      });
                      const response3 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/academic-uploads?filters[application][documentId][$eq]=${documentId}&populate=*
                      `, {
                          headers: {
                              'Authorization': `Bearer ${token}`, // Your JWT token
                              'Content-Type': 'application/json'
                          }
                      });
                      const response4 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/documents-uploads?filters[application][documentId][$eq]=${documentId}&populate=*
                      `, {
                          headers: {
                              'Authorization': `Bearer ${token}`, // Your JWT token
                              'Content-Type': 'application/json'
                          }
                      });
                      const response5 = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/finance-details?filters[application][documentId][$eq]=${documentId}&populate=*
                      `, {
                          headers: {
                              'Authorization': `Bearer ${token}`, // Your JWT token
                              'Content-Type': 'application/json'
                          }
                      });
                    const data2 = await response2.json();
                    const data3 = await response3.json();
                    const data4 = await response4.json();
                    const data5 = await response5.json();
                    console.log('Full application details2', data2.data);
                    console.log('Full application details3', data3.data);
                    console.log('Full application details4', data4.data);
                    console.log('Full application details5', data5.data);
  
  
                    localStorage.setItem("acedemic_detail", data2.data[0].id);
                    localStorage.setItem("marksheet", data3.data[0].id);
                    localStorage.setItem("Finance_detail", data5.data[0].id);
                    localStorage.setItem("require_document", data4.data[0].id);
                  } catch (error) {
                    console.error('Error fetching full application details:', error);
                  }
    
                } else {
                  localStorage.setItem("application_status", "incomplete");
  
                  console.log('No applications related to the latest campaign found for the user');
                }
              } catch (error) {
                console.error("Error fetching campaigns or user applications:", error);
              }
            } else {
              console.error("Unexpected user type:", type);
            }
          } else {
            console.error("Invalid response:", response);
          }
        } else {
          // setErrors({ ...errors, message: response.data.message });
        }
      } catch (error) {
        console.log("error", error.response?.data?.error?.message);
    
        // let auth_user_info = { email };
        // localStorage.setItem("auth_user_info", JSON.stringify(auth_user_info));
    
        // setErrors({
        //   ...errors,
        //   message: "Your account is not active by an administrator.",
        // });
    
        // setTimeout(() => {
        //   navigate("/signup");
        // }, 3000);
      }
    
    };

    

    
    
    
    
    

    // Fetch Applications information and download as CSV
    const fetchDataAndDownload = async () => {
      setLoading(true);
    
      try {
        const token = localStorage.getItem("token");
        const pageSize = 100; // Fetch 100 records at a time
        let currentPage = 1;
        let allApplications = [];
        let totalPages = 1;
    
        // Determine the API endpoint based on filters
        let api = `${process.env.REACT_APP_BASE_URL_strapi}/applications?populate=personal_statements`;
    
        if (status) {
          api += `&filters[application_status][$eq]=${status}`;
        } else if (gender) {
          api += `&filters[gender][$eq]=${gender}&filters[$and][1][$or][0][application_status][$eq]=new&filters[$and][1][$or][1][application_status][$eq]=rejected&filters[$and][1][$or][2][application_status][$eq]=final_stage&filters[$and][1][$or][2][application_status][$eq]=approved`;
        } else if (province) {
          api += `&filters[province][$eq]=${province}&filters[$and][1][$or][0][application_status][$eq]=new&filters[$and][1][$or][1][application_status][$eq]=rejected&filters[$and][1][$or][2][application_status][$eq]=final_stage&filters[$and][1][$or][2][application_status][$eq]=approved`;
        }
    
        api += `&sort=${sortField}:${sortOrder}&pagination[pageSize]=${pageSize}`;
    
        // Fetch all pages
        do {
          const paginatedApi = `${api}&pagination[page]=${currentPage}`; // Add page number
          console.log("Fetching from API:", paginatedApi);
    
          const response = await fetch(paginatedApi, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
    
          if (response.ok) {
            const responseData = await response.json();
            const applications = responseData.data;
    
            // Append the fetched applications to the main list
            allApplications = [...allApplications, ...applications];
    
            // Update pagination info
            totalPages = responseData.meta.pagination.pageCount;
            currentPage++; // Increment page for next fetch
          } else {
            console.error("Failed to fetch applications:", response.statusText);
            break;
          }
        } while (currentPage <= totalPages);
    
        // Process the applications to calculate sums and include additional fields
        const processedApplications = allApplications.map((application) => {
          const evaluations = application.evaluations?.data || [];
    
          const updatedEvaluations = evaluations.map((evaluation) => {
            const attributes = evaluation;
            const sum =
              (attributes.creativity || 0) +
              (attributes.expression || 0) +
              (attributes.future_ambition || 0) +
              (attributes.past_ambition || 0) +
              (attributes.relevance || 0);
    
            return {
              ...evaluation,
              sum, // Add the sum field to the evaluation
              next_stage: attributes.next_stage, // Add the next_stage field to the evaluation
            };
          });
    
          return {
            ...application,
            attributes: {
              ...application.attributes,
              evaluations: {
                ...application.evaluations,
                data: updatedEvaluations,
              },
            },
          };
        });
    
        // Convert processed data to CSV
        console.log("processedApplications",processedApplications)
        const csvData = jsonToCsv(processedApplications);
    
        // Create Blob from CSV data and download it
        const blob = new Blob([csvData], { type: "text/csv;charset=UTF-8" });
        FileSaver.saveAs(blob, `applicant_data.csv`);
    
        setLoading(false);
      } catch (error) {
        console.error("Error fetching and downloading data:", error);
        setLoading(false);
      }
    };
    
        // if (type === "report") {
        //   console.log("1111")
        //     // Convert JSON data to CSV
        //     console.log("realapplications ====>",realapplications)
        //     const csvData = jsonToCsv(realapplications);
        //     // console.log(csvData);

        //     const blob = new Blob([csvData], { type: 'text/csv;charset=UTF-8' });

        //     // Use FileSaver to save the Blob as a CSV file
        //     FileSaver.saveAs(blob, `${title}.csv`);

        //     setLoading(false);
        // } else {
        //   console.log("2222")

        //     try {
        //         const response = await axios.get(
        //             `${process.env.REACT_APP_BASE_URL}/applicant/get-application-export-list`,
        //             {
        //                 headers: {
        //                     accept: "*/*",
        //                     Event: event,
        //                     SessionKey: "123",
        //                 }
        //             }
        //         );
        //         const data = response.data.data; // Extract the data array from the response

        //         // Check if data is null or undefined
        //         if (!data) {
        //             console.log('No data received');
        //             return;
        //         }


        //         // Convert JSON data to CSV
        //         const csvData = jsonToCsv(data);
        //         // console.log(csvData);

        //         // Create a Blob from the CSV data
        //         const blob = new Blob([csvData], { type: 'text/csv;charset=UTF-8' });

        //         // Use FileSaver to save the Blob as a CSV file
        //         FileSaver.saveAs(blob, 'data.csv');

        //         setLoading(false);

        //     } catch (error) {
        //         console.error("Error fetching personal information data:", error);
        //         setLoading(false);
        //     }
        // }


  
    const yes = async (id) => {
    
      if (!id || !token) {
        alert("Application ID or Token missing!");
        return;
      }
    
      let  outgoingData = {
        application_status:'final_stage'
      }           
     try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
          method: 'PUT', 
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json', // Ensure content-type is set to JSON
          },
          body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
        });
    
        if (!response.ok) {
          throw new Error('Failed to submit form');
        }
        NotificationManager.success("Application Moved To Final list");
        window.location.reload();

        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.error('Error:', error);
      }


    };
    
  const no = async (id) => {
    
    if (!id || !token) {
      alert("Application ID or Token missing!");
      return;
    }
  
    let  outgoingData = {
      application_status:'rejected'
    }           
   try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
        method: 'PUT', 
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json', // Ensure content-type is set to JSON
        },
        body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
      });
  
      if (!response.ok) {
        throw new Error('Failed to submit form');
      

      }
      NotificationManager.success("Application Moved To Rejacted");
      window.location.reload();
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error('Error:', error);
    }



};
const recover = async (id) => {
    
  if (!id || !token) {
    alert("Application ID or Token missing!");
    return;
  }

  let  outgoingData = {
    application_status:'new'
  }           
 try {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
      method: 'PUT', 
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json', // Ensure content-type is set to JSON
      },
      body: JSON.stringify({ data: outgoingData }) // Send the data wrapped in a 'data' object
    });

    if (!response.ok) {
      throw new Error('Failed to submit form');
    }
    NotificationManager.success("Application Moved To new ");

    const data = await response.json();
    window.location.reload();

    console.log(data);
  } catch (error) {
    console.error('Error:', error);
  }

};

const changeStatus = async (id, newStatus) => {
  if (!id || !token) {
    alert("Application ID or Token missing!");
    return;
  }

  let outgoingData = {
    application_status: newStatus
  };
  try {
    const response = await fetch(`${process.env.REACT_APP_BASE_URL_strapi}/applications/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data: outgoingData })
    });

    if (!response.ok) {
      throw new Error('Failed to change status');
    }
    NotificationManager.success(`Application moved to ${newStatus}`);
    window.location.reload();
  } catch (error) {
    console.error('Error changing status:', error);
    NotificationManager.error("Failed to change status. Please try again.");
  }
};

    // Remarks column helpers -------------------------------------------------

    // The draft wins while the admin is typing; the saved value otherwise.
    const getRemarksValue = (application) =>
      remarksDrafts[application.id] !== undefined
        ? remarksDrafts[application.id]
        : application.remarks || "";

    const handleRemarksChange = (applicationId, value) =>
      setRemarksDrafts((previous) => ({ ...previous, [applicationId]: value }));

    const remarksUnsaved = (application) =>
      getRemarksValue(application) !== (application.remarks || "");

    const saveRemarks = async (application) => {
      const value = getRemarksValue(application);

      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL_strapi}/applications/${application.id}`,
          {
            method: "PUT",
            headers: {
              "Authorization": `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ data: { remarks: value } }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to save remarks");
        }

        // Update the row in place so the table reflects the save without a reload
        setRealApplications((previous) =>
          previous.map((item) =>
            item.id === application.id ? { ...item, remarks: value } : item
          )
        );
        setRemarksDrafts((previous) => {
          const next = { ...previous };
          delete next[application.id];
          return next;
        });

        NotificationManager.success("Remarks saved");
      } catch (error) {
        console.error("Error saving remarks:", error);
        NotificationManager.error("Failed to save remarks. Please try again.");
      } finally {
        setLoading(false);
      }
    };


    return (
        <div>
            {loading ? (
                <div className="d-flex justify-content-center">
                    <div className="spinner-bubble spinner-bubble-primary m-5"></div>
                </div>
            ) : (<div className="card">
                <div className="card-body">
                    <div className="simple-card-title d-flex justify-content-between align-items-center">
                        <div>
                            <h3 className="text-capitalize mb-1">{title}</h3>
                            <small className="text-muted">
                                {sortField === "createdAt"
                                  ? "Newest applications first"
                                  : `Sorted by ${sortField === "name" ? "Full Name" : sortField === "city" ? "Permanent City" : "Temporary City"} (${sortOrder === "asc" ? "ascending" : "descending"})`}
                            </small>
                        </div>
                        <button className="btn-icon m-1 text-capitalize btn btn-primary text-white" onClick={fetchDataAndDownload}>
                            <span className="ul-btn__icon">
                                <i className="i-File-Excel"></i>
                            </span>
                            <span className="ul-btn__text">Export Data</span>
                        </button>
                    </div>
                    {realapplications && realapplications.length > 0 && (
  <table className="table table-bordered">
    <thead>
   <tr>
     {/* Other fixed column headers */}
     {renderSortableHeader("Full Name", "name")}
     {['Primary Email', 'Address', 'Phone Number'].map((key) => (
       <th key={key}>{key}</th>
     ))}
     {renderSortableHeader("Permanent City", "city")}
     {renderSortableHeader("Temporary City", "temp_city")}
     {/* Dynamic headers for evaluations */}
     {['assad', 'fahad'].map((name) => (
       <th key={name}>{name}</th>
     ))}
     {check === 'finance' && <>
       <th key="requested-funds">Requested Funds</th>
       <th key="allocated-funds">Allocated Funds</th>
     </>}
     {/* Admin remarks: one shared textarea per application row, saved through PUT /applications/:id */}
     <th>Remarks</th>
     <th>Select</th>
   </tr>
 </thead>
    <tbody>
    {realapplications.map((application) => (
   <tr key={application.id}>
   {/* Mapping regular fields */}
   {['name', 'email', 'permenent_address', 'phone_number'].map((key) => (
     <td key={key}>
       {application[key] || 'N/A'}
     </td>
   ))}

   {/* City Columns */}
   <td key="permanent-city">{application.city || 'N/A'}</td>
   <td key="temp-city">{application.temp_city || 'N/A'}</td>

   {/* Admin Columns (evaluations data under correct headings) */}
   {['assad', 'fahad'].map((name, index) => {
 const evaluation = application.evaluations?.find(
   (evaluationObj) =>
     evaluationObj.users_permissions_user?.username?.toLowerCase() ===
     name.toLowerCase()
 );
console.log("evaluation",evaluation)
 const username = evaluation?.users_permissions_user?.username || 'N/A';
 console.log("username",username)

 const sum = evaluation?.sum !== undefined && evaluation?.sum !== null ? evaluation.sum : 'N/A';
 const nextStage = evaluation?.next_stage; // Retrieve next_stage
 const backgroundColor = nextStage === true ? 'lightgreen' : nextStage === false ? 'lightcoral' : 'transparent';

 return (
   <td key={name} style={{ backgroundColor }}>
     <strong>{username !== 'N/A' ? `${sum}` : 'N/A'}</strong>
   </td>
 );
   })}

    {/* Finance Columns */}
    {check === 'finance' && <>
      <td key="requested-funds">
        {(() => {
          const fundsReq = Array.isArray(application.finance_details)
            ? application.finance_details[0]?.funds_request
            : application.finance_details?.funds_request;
          return fundsReq ? `PKR ${fundsReq}` : 'N/A';
        })()}
      </td>
      <td key="allocated-funds">
        {(() => {
          const amount = Array.isArray(application.finance_amount)
            ? application.finance_amount[0]?.amount
            : application.finance_amount?.amount;
          return amount ? `PKR ${amount}` : 'N/A';
        })()}
      </td>
    </>}

    {/* Select Button */}

    {/* Remarks Column: inline textarea, Save is only enabled once the text differs from the saved value */}
    <td>
      <div className="d-flex flex-column gap-1" style={{ minWidth: 180 }}>
        <textarea
          className="form-control"
          rows={2}
          placeholder="Add remarks..."
          value={getRemarksValue(application)}
          onChange={(event) =>
            handleRemarksChange(application.id, event.target.value)
          }
        />
        <button
          type="button"
          className="btn btn-sm btn-outline-primary align-self-end"
          disabled={!remarksUnsaved(application)}
          onClick={() => saveRemarks(application)}
        >
          Save
        </button>
      </div>
    </td>

    {/* ----------------- POPUP MODAL ----------------- */}
<div
  className={`modal fade ${showPopup ? "show d-block" : ""}`}
  tabIndex="-1"
  style={{ background: "rgba(0,0,0,0.5)" }}
>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">

      <div className="modal-header">
        <h5 className="modal-title">Financial Allocation</h5>
        <button type="button" className="btn-close" onClick={() => setShowPopup(false)} />
      </div>

      <div className="modal-body">
        <div className="mb-3">
          <label className="form-label">Requested Funds</label>
          <input
            type="number"
            className="form-control"
            value={fundsRequested ||0}
            disabled
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Challan Amount</label>
          <input
            type="number"
            className="form-control"
            value={chalan ||0}
            disabled
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Allocated Funds</label>
          <input
            type="number"
            className="form-control"
            value={allocatedFunds || 0}
            onChange={(e) => setAllocatedFunds(e.target.value)}
          />
        </div>
      </div>

      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={() => setShowPopup(false)}>
          Cancel
        </button>

        <button className="btn btn-primary" style={{color:"white"}} onClick={handleFinanceSave}>
          Save
        </button>
      </div>

    </div>
  </div>
</div>


    <td>
    {status === 'new' ? (
  event === 'verified' ? (
    <div>
      <button
      type="button"
      className="btn-icon m-1 text-capitalize btn btn-outline-primary"
      onClick={() => navigate(`/applications/view-application/${application.documentId}`)}
    >
      <span className="ul-btn__icon">
        <i className="i-Information"></i>
      </span>
      View
    </button>
    <button
    type="button"
    className="btn-icon m-1 text-capitalize btn btn-outline-success"
    onClick={() => changeStatus(application.id, 'incomplete')}
  >
    <span className="ul-btn__icon">
      <i className="i-Arrow-Right"></i>
    </span>
    Make Draft
  </button>
    <button
    type="button"
    className="btn-icon m-1 text-capitalize btn btn-outline-success"
    onClick={() => changeStatus(application.id, 'verified')}
  >
    <span className="ul-btn__icon">
      <i className="i-Checked"></i>
    </span>
    Mark as Verified
  </button>
    <button
    type="button"
    className="btn-icon m-1 text-capitalize btn btn-outline-danger"
    onClick={() => changeStatus(application.id, 'disqualified')}
  >
    <span className="ul-btn__icon">
      <i className="i-Close-Window"></i>
    </span>
    Disqualify
  </button>

    </div>
  ) : (
  <div>
    <button
    type="button"
    className="btn-icon m-1 text-capitalize btn btn-outline-primary"
    onClick={() => navigate(`/applications/view-application/${application.documentId}`)}
  >
    <span className="ul-btn__icon">
      <i className="i-Information"></i>
    </span>
    View
  </button>
  <button
  type="button"
  className="btn-icon m-1 text-capitalize btn btn-outline-success"
  onClick={() => changeStatus(application.id, 'incomplete')}
>
  <span className="ul-btn__icon">
    <i className="i-Arrow-Right"></i>
  </span>
  Make Draft
</button>

  </div>
  )
) : status === 'verified' ? (
  <div>
    <button
    type="button"
    className="btn-icon m-1 text-capitalize btn btn-outline-primary"
    onClick={() => navigate(`/applications/view-application/${application.documentId}`)}
  >
    <span className="ul-btn__icon">
      <i className="i-Information"></i>
    </span>
    View
  </button>
    <button
      type="button"
      className="btn-icon m-1 text-capitalize btn btn-outline-primary"
      onClick={() => handleLoginByEmail(application.email)}
    >
      <span className="ul-btn__icon">
        <i className="i-Information"></i>
      </span>
      Login
    </button>
  </div>
) : status === 'final_stage' ? (
  <div>
    {check === 'finance' ? (
      <div>
      <button
        type="button"
        className="btn-icon m-1 text-capitalize btn btn-outline-primary"
        onClick={() => navigate(`/applications/view-application/${application.documentId}`)}
      >
        <span className="ul-btn__icon">
          <i className="i-Edit"></i>
        </span>
        Edit
      </button>
      <button
      type="button"
      className="btn-icon m-1 text-capitalize btn btn-outline-primary"
      onClick={() => handleLoginByEmail(application.email)}
    >
      <span className="ul-btn__icon">
        <i className="i-Information"></i>
      </span>
      Login
    </button>
    </div>
      
    ) : (
      // Show the View and Reject buttons if check is not 'finance'
      <>
        
        <button
          type="button"
          className="btn-icon m-1 text-capitalize btn btn-outline-primary"
          onClick={() => no(application.id)}
        >
          Reject
        </button>
        <button
      type="button"
      className="btn-icon m-1 text-capitalize btn btn-outline-primary"
      onClick={() => handleLoginByEmail(application.email)}
    >
      <span className="ul-btn__icon">
        <i className="i-Information"></i>
      </span>
      Login
    </button>
      </>
    )}
  </div>
): status === 'approved' ? (
  <div>
  <button
      type="button"
      className="btn-icon m-1 text-capitalize btn btn-outline-primary"
      onClick={() => navigate(`/applications/view-application/${application.documentId}`)}
    >
      <span className="ul-btn__icon">
        <i className="i-Information"></i>
      </span>
      View
    </button>
        <button
          type="button"
          className="btn-icon m-1 text-capitalize btn btn-outline-primary"
          onClick={() => openFinancePopup(application.documentId,application.id)}

        >
          Yes
        </button>
        <button
          type="button"
          className="btn-icon m-1 text-capitalize btn btn-outline-primary"
          onClick={() => no(application.id)}
        >
          No
        </button>
        <button
      type="button"
      className="btn-icon m-1 text-capitalize btn btn-outline-primary"
      onClick={() => handleLoginByEmail(application.email)}
    >
      <span className="ul-btn__icon">
        <i className="i-Information"></i>
      </span>
      Login
    </button>
    </div>
  ): (
  <div>
  <button
    type="button"
    className="btn-icon m-1 text-capitalize btn btn-outline-primary"
    onClick={() => navigate(`/applications/view-application/${application.documentId}`)}
  >
    <span className="ul-btn__icon">
      <i className="i-Information"></i>
    </span>
    View
  </button>
   <button
   type="button"
   className="btn-icon m-1 text-capitalize btn btn-outline-primary"
   onClick={() => recover(application.id)}
 >
   Recover
 </button>
 <button
      type="button"
      className="btn-icon m-1 text-capitalize btn btn-outline-primary"
      onClick={() => handleLoginByEmail(application.email)}
    >
      <span className="ul-btn__icon">
        <i className="i-Information"></i>
      </span>
      Login
    </button>
 </div>
)}
    </td>
  </tr>
))}

    </tbody>
  </table>
  )}




                </div>
            </div>
            )}
               <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        breakLabel={"..."}
        pageCount={totalPages}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={({ selected }) => setCurrentPage(selected)}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
      <NotificationContainer/>
        </div>
    );
};

export default DashboardTable;


// {
//     "data": [
//         {
//             "reference": "DeveDeem IS Demo Direct AT Demo Organization",
//             "address": "Living in Lahore, Faisalabad, Punjab",
//             "name": "Nadeem R Archer",
//             "id": 9,
//             "file": "http://techmac.ovh/rfmse/ReferenceFileUpload/Reference9",
//             "gender": "Male",
//             "disability": "No ",
//             "nationality": "Foreign National",
//             "contact": "+923012345678, +92515347372",
//             "email": "nademo@gmail.com, testnadeem@g.com",
//             "score": 0,
//             "graceScore": 0,
//             "resume": "http://techmac.ovh/rfmse/ReferenceFileUpload/Resume9",
//             "experience": "4",
//             "coverLetter": "Nadeem Statement",
//             "skills": "Nadeem skill",
//             "dob": "2023-12-21",
//             "network": "Linked In",
//             "totalScore": 0,
//             "fundingRequest": "1",
//             "education": "16"
//         },
//         {
//             "reference": "jjh IS yuu AT ytyt",
//             "address": "3Aj905hvflknh klre[oktregpijnm 12245----, Gakuch, Gilgit-Baltistan",
//             "name": "Muhammad  Mustafa",
//             "id": 23,
//             "file": "http://techmac.ovh/rfmse/ReferenceFileUpload/Reference23",
//             "gender": "Male",
//             "disability": "No ",
//             "nationality": "Foreign National",
//             "contact": "+923334383455",
//             "email": "mustafa-amjad@hotmail.com",
//             "score": 0,
//             "graceScore": 0,
//             "resume": "http://techmac.ovh/rfmse/ReferenceFileUpload/Resume23",
//             "experience": "4",
//             "coverLetter": "rtsytjhg hgjhjh hghgj ghh 4565  ytu 455666 5666 -- 00n hfgjh ",
//             "skills": "hjjytuyt ygyut n tyuyui ry t ",
//             "dob": "2222-02-22",
//             "network": "Website",
//             "totalScore": 0,
//             "fundingRequest": null,
//             "education": "16"
//         }
//     ],
//     "status": 200,
//     "message": "New Applications"
// }